import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IClientFormMeta } from '@Modules/terminalManagementSystem/merchant/containers/tableHandlers/merchantConsultation/merchantConsultationDetails/client/ClientMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';

type Props = {
  onSubmit: any,
  meta: IClientFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const ClientFormUI = ({ meta, onSubmit, isSubmitting, isLoading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={10}>
        {displayCustomInputs(
          meta,
          register,
          errors,
          isLoading,
          ['companyName', 'DBAName', 'type', 'city'],
        )}
      </CC.SimpleGrid>

       <CC.Box mt="2%" as="fieldset"
      p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'}>
        <CC.Heading px={2} as={"legend"} fontSize='md'>Identification</CC.Heading>
        <CC.SimpleGrid columns={{base: 1, md: 2, lg: 3}} spacing={10} my={10}>
          {displayCustomInputs<IClientFormMeta>(meta, register, errors, isLoading, ['licence', 'tradeRegisterNumber', 'siretNumber', 'taxIdentificationNumber', 'socialSecurityNumber', 'capital'])}
        </CC.SimpleGrid>
      </CC.Box>

      <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={10}>
        {displayCustomInputs(
          meta,
          register,
          errors,
          isLoading,
          ['contractNumber', 'creationDate', 'signatureDate', 'statusDate'],
        )}
      </CC.SimpleGrid>

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default ClientFormUI;
